/* 
  Legacy Function - Get and format Store Data
  This function uses the legacy data scheme that we used with Strapi V3. 
  Do not use unless you are attempting to fetch the store data from a project using Strapi V3.
*/

import { getDiscount } from '../../../helpers/purchase/get-discount'

export function getStoreInfoLegacy(productLinks, storesData, customStoresData, productPromos, locale) {
  if (!storesData || storesData === null) {
    return ''
  }

  const product = productLinks && productLinks.gameId && productLinks.gameId !== null ? productLinks.gameId : null
  let storeLinks = []
  storesData?.find((e) => e.locale == locale).stores.map((store) => {
    const productLink = productLinks ? productLinks[store.platformID] : null
    const purchaseState = productLink && productLink !== null && productLink.productState ? productLink.productState : 'released'

    if (!productLink || productLink === null) {
      return ''
    }

    // Set default data for each stores
    let platformType = store.category

    let title = store.title
    let logoSmall = store.logoSmall ? store.logoSmall : null
    let logoLarge = store.logoLarge ? store.logoLarge : null
    let logoAlternate = store.logoAlternate ? store.logoAlternate : null
    let logoSmallSize = store.logoSmallSize ? store.logoSmallSize : null
    let logoLargeSize = store.logoLargeSize ? store.logoLargeSize : null

    // Use the project's custom data if available, or use the default store data
    const customData = customStoresData && customStoresData !== null ? customStoresData.find((e) => e.platformID == store.platformID) : null
    if (customData && customData !== null) {
      customData.category && (
        platformType = customData.category
      )
      customData.title && (
        title = customData.title
      )
      customData.smallLogo && (
        logoSmall = customData.smallLogo
      )
      customData.largeLogo && (
        logoLarge = customData.largeLogo
      )
      customData.alternateLogo && (
        logoAlternate = customData.alternateLogo
      )
      customData.smallLogoSize && (
        logoSmallSize = customData.smallLogoSize
      )
      customData.largeLogoSize && (
        logoLargeSize = customData.largeLogoSize
      )
    }

    // Set active promotions to product
    const promos = productPromos && productPromos !== null ? productPromos : null
    let promoValue = null
    if (promos !== null) {
      let discounts = promos.discounts
      //let freeWeekEnds = promos.freeWeekEnds
      promoValue = getDiscount(store.platformID, product, discounts)
    }

    const storeLink = {
      platformID: store.platformID,
      platformType: platformType,
      purchaseState: purchaseState,
      title: title,
      link: productLink,
      logoSmall: logoSmall,
      logoLarge: logoLarge,
      logoAlternate: logoAlternate,
      logoSmallSize: logoSmallSize,
      logoLargeSize: logoLargeSize,
      promotion: promoValue
    }
    storeLinks.push({ ...storeLink })
  })

  return storeLinks
}
